'use client';

import { Conditional } from '@cat-ecom/pcc-components';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function IframeRedirect({ children }) {
  const [isRenderedInIframe, setIsRenderedInIframe] = useState(true);
  const isOrderConfirmationPage = usePathname().match(
    /orders\/.*\/confirmation/
  );

  /**
   * This component does the redirection from iframe to the top level pages,
   * if we are doing a redirection from CATSAS project inside an iframe
   */
  useEffect(() => {
    if (window.self !== window.top && isOrderConfirmationPage) {
      window.top.location = window.self.location;
    } else {
      setIsRenderedInIframe(false);
    }
  }, [isOrderConfirmationPage]);

  return (
    <Conditional test={!isRenderedInIframe || !isOrderConfirmationPage}>
      {children}
    </Conditional>
  );
}
